<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <span class="accordion-toggle">
          <!-- @click="toggleIsOpen()"> -->
        <h4 class="panel-title">
            <slot name="header">
              {{ header }}
            </slot>
        </h4>
      </span>
    </div>
    <!-- <div class="panel-collapse" v-el:panel v-show="isOpen" transition="collapse"> -->
    <!-- remove transtion to avoid bug for now -->
    <div class="panel-collapse" v-el:panel v-show="isOpen">
      <div class="panel-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import coerceBoolean from './utils/coerceBoolean.js'

export default {
  props: {
    isOpen: {
      type: Boolean,
      coerce: coerceBoolean,
      default: false
    },
    header: {
      type: String
    }
  },
  methods: {
    toggleIsOpen () {
      this.isOpen = !this.isOpen
      this.$dispatch('isOpenEvent', this)
    }
  },
  transitions: {
    collapse: {
      afterEnter: function afterEnter (el) {
        el.style.maxHeight = ''
      },
      beforeLeave: function beforeLeave (el) {
        el.style.maxHeight = el.offsetHeight + 'px'
        // Recalculate DOM before the class gets added.
        return el.offsetHeight
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';

.panel {
  border: 1px solid $BS_panel_border;
  .panel-heading {
    color: $BS_panel_heading_fg;
    background-color: $BS_panel_heading_bg;
  }
  .panel-title{
    font-size: 18px;
    @include breakpoint(xxs){
      font-size: 16px;
    }
    white-space:nowrap;
  }
  .panel-body{
    background-color: $BS_panel_body_bg;
    font-size: 16px;
    @include breakpoint(xxs){
      font-size: 12px;
      padding: 7px;
    }
    & label{
      @include breakpoint(xxs){
        font-size: 14px;
      }
    }
  }
}

.accordion-toggle {
  cursor: default !important;
  text-decoration: none;
  &:hover{
    text-decoration: none;
    color: $BS_panel_heading_fg;
  }
}

.collapse-transition {
  transition: max-height .5s ease;
  overflow: hidden;
}

.collapse-enter, .collapse-leave {
  max-height: 0!important;
}
</style>



// WEBPACK FOOTER //
// Edid-panel.vue?00613935